import AuthRequired from "../utils/AuthRequired";

import Dashboard from "../views/ehms/dashboard/Dashboard";

import VendorsList from "../views/ehms/vendors/VendorsList";
import VendorSummary from "../views/ehms/vendors/VendorSummary";
import VendorFacilitiesList from "../views/ehms/vendors/summary/VendorFacilitiesList";
import VendorUnitsList from "../views/ehms/vendors/summary/VendorUnitsList";
import VendorAdmissionsList from "../views/ehms/vendors/summary/VendorAdmissionsList";
import VendorInspectionsList from "../views/ehms/vendors/summary/VendorInspectionsList";
import VendorBillingsList from "../views/ehms/vendors/summary/VendorBillingsList";

import FacilitiesList from "../views/ehms/locations/faciliites/FacilitiesList";
import FacilitySummary from "../views/ehms/locations/faciliites/FacilitySummary";
import FacilityUnitsList from "../views/ehms/locations/faciliites/summary/FacilityUnitsList";
import FacilityAdmissionsList from "../views/ehms/locations/faciliites/summary/FacilityAdmissionsList";
import FacilityInspectionsList from "../views/ehms/locations/faciliites/summary/FacilityInspectionsList";
import FacilitySignaturesList from "../views/ehms/locations/faciliites/summary/FacilitySignaturesList";
import FacilityBillingsList from "../views/ehms/locations/faciliites/summary/FacilityBillingsList";
import FacilityComplaintsList from "../views/ehms/locations/faciliites/summary/FacilityComplaintsList";
import FacilityIncidentsList from "../views/ehms/locations/faciliites/summary/FacilityIncidentsList";
import FacilityFilesList from "../views/ehms/locations/faciliites/summary/FacilityFilesList";

import FloorsList from "../views/ehms/locations/floors/FloorsList";

import UnitsList from "../views/ehms/locations/units/UnitsList";

import BillingsList from "../views/ehms/locations/billings/BillingsList";
import BillingSummary from "../views/ehms/locations/billings/BillingSummary";

import SignaturesList from "../views/ehms/signatures/signatures/SignaturesList";
import SignaturesArchivedList from "../views/ehms/signatures/archived/SignaturesArchivedList";
import SignaturesApprovalList from "../views/ehms/signatures/approval/SignaturesApprovalList";
import SignatureSummary from "../views/ehms/signatures/signatures/SignatureSummary";

import AdmissionsList from "../views/ehms/clients/admissions/AdmissionsList";

import ClientsList from "../views/ehms/clients/clients/ClientsList";
import ClientSummary from "../views/ehms/clients/clients/ClientSummary";

import InspectionsList from "../views/ehms/inspections/inspections/InspectionsList";

import InspectionSummary from "../views/ehms/inspections/inspections/InspectionSummary";

import ConcernsList from "../views/ehms/inspections/concerns/ConcernsList";

import CategoriesList from "../views/ehms/inspections/categories/CategoriesList";

import DetailsList from "../views/ehms/inspections/details/DetailsList";

import ComplaintsList from "../views/ehms/compliances/complaints/ComplaintsList";
import ComplaintSummary from "../views/ehms/compliances/complaints/ComplaintSummary";

import IncidentsList from "../views/ehms/compliances/incidents/IncidentsList";
import IncidentSummary from "../views/ehms/compliances/incidents/IncidentSummary";

import UsersList from "../views/users/users/UsersList";
import RolesList from "../views/users/roles/RolesList";
import PermissionsList from "../views/users/permissions/PermissionsList";
import UserSummary from "../views/users/users/UserSummary";

import Settings from "../views/ehms/settings/Settings";

import VendorsReport from "../views/ehms/reports/VendorsReport";
import FacilitiesReport from "../views/ehms/reports/FacilitiesReport";
import ClientsReport from "../views/ehms/reports/ClientsReport";
import AdmissionsReport from "../views/ehms/reports/AdmissionsReport";
import VacancyReport from "../views/ehms/reports/VacancyReport";
import OccupancyReport from "../views/ehms/reports/OccupancyReport";
import BillingsReport from "../views/ehms/reports/BillingsReport";
import InspectionsReport from "../views/ehms/reports/InspectionsReport";
import ComplaintsReport from "../views/ehms/reports/ComplaintsReport";
import IncidentsReport from "../views/ehms/reports/IncidentsReport";
import SigntureReport from "../views/ehms/reports/signatures/SignatureReport";

export default [
    {
        path: "/",
        redirect: '/hms',
    },
    {
        path: "/hms",
        component: () => import("../views"),
        beforeEnter: AuthRequired,
        children: [
            {
                path: "/", component: Dashboard,
            },
            {
                path: "vendors", name: 'vendors', component: VendorsList,
            },
            {
                path: "vendors/:vendor_id", name: 'vendors.show', component: VendorSummary,
                children: [
                    {
                        path: "facilities", name: 'vendors.facilities', component: VendorFacilitiesList,
                    },
                    {
                        path: "units", name: 'vendors.units', component: VendorUnitsList,
                    },
                    {
                        path: "admissions", name: 'vendors.admissions', component: VendorAdmissionsList
                    },
                    {
                        path: "inspections", name: 'vendors.inspections', component: VendorInspectionsList
                    },
                    {
                        path: "billings", name: 'vendors.billings', component: VendorBillingsList
                    },
                ],
            },
            {
                path: "locations",
                component: () => import("../views/ehms/locations"),
                children: [
                    {
                        path: "facilities", name: 'facilities', component: FacilitiesList,
                    },
                    {
                        path: "facilities/:facility_id", name: 'facilities.show', component: FacilitySummary,
                        children: [
                            {
                                path: "units", name: 'facilities.units', component: FacilityUnitsList,
                            },
                            {
                                path: "admissions", name: 'facilities.admissions', component: FacilityAdmissionsList
                            },
                            {
                                path: "inspections", name: 'facilities.inspections', component: FacilityInspectionsList
                            },
                            {
                                path: "signatures", name: 'facilities.signatures', component: FacilitySignaturesList
                            },
                            {
                                path: "billings", name: 'facilities.billings', component: FacilityBillingsList
                            },
                            {
                                path: "complaints", name: 'facilities.complaints', component: FacilityComplaintsList
                            },
                            {
                                path: "incidents", name: 'facilities.incidents', component: FacilityIncidentsList
                            },
                            {
                                path: "files", name: 'facilities.files', component: FacilityFilesList,
                            },
                        ],
                    },
                    {
                        path: "floors", component: FloorsList,
                    },
                    {
                        path: "floors/:floor_id", component: FloorsList,
                    },
                    {
                        path: "units", component: UnitsList,
                    },
                    {
                        path: "units/:unit_id", component: UnitsList,
                    },
                    {
                        path: "billings", component: BillingsList,
                    },
                    {
                        path: "billings/:billing_id", component: BillingSummary,
                    },
                ]
            },
            {
                path: "signatures",
                component: () => import("../views/ehms/signatures"),
                children: [
                    {
                        path: "list", component: SignaturesList,
                    },
                    {
                        path: "list/:signature_id", component: SignatureSummary,
                    },
                    {
                        path: "approvals", component: SignaturesApprovalList,
                    },
                    {
                        path: "archived", component: SignaturesArchivedList,
                    },
                ]
            },
            {
                path: "clients",
                component: () => import("../views/ehms/clients"),
                children: [
                    {
                        path: "admissions", component: AdmissionsList,
                    },
                    {
                        path: "list", component: ClientsList,
                    },
                ]
            },
            {
                path: "clients/list/:client_id", name: 'client.show', component: ClientSummary,
            },
            {
                path: "inspections",
                component: () => import("../views/ehms/inspections"),
                children: [
                    {
                        path: "list", component: InspectionsList,
                    },
                    {
                        path: "list/:inspection_id", component: InspectionSummary,
                    },
                    {
                        path: "details", component: DetailsList,
                    },
                    {
                        path: "categories", component: CategoriesList,
                    },
                    {
                        path: "concerns", component: ConcernsList,
                    },
                ]
            },
            {
                path: "compliances",
                component: () => import("../views/ehms/compliances"),
                children: [
                    {
                        path: "complaints", component: ComplaintsList,
                    },
                    {
                        path: "complaints/:complaint_id", name: 'complaint.show', component: ComplaintSummary,
                    },
                    {
                        path: "incidents", component: IncidentsList,
                    },
                    {
                        path: "incidents/:incident_id", name: 'incident.show', component: IncidentSummary,
                    },
                ]
            },
            {
                path: "reports",
                component: () => import("../views/ehms/reports"),
                children: [
                    {
                        path: "vendors", component: VendorsReport,
                    },
                    {
                        path: "facilities", component: FacilitiesReport,
                    },
                    {
                        path: "clients", component: ClientsReport,
                    },
                    {
                        path: "admissions", component: AdmissionsReport,
                    },
                    {
                        path: "vacancy", component: VacancyReport,
                    },
                    {
                        path: "occupancy", component: OccupancyReport,
                    },
                    {
                        path: "billings", component: BillingsReport,
                    },
                    {
                        path: "inspections", component: InspectionsReport,
                    },
                    {
                        path: "complaints", component: ComplaintsReport,
                    },
                    {
                        path: "incidents", component: IncidentsReport,
                    },
                    {
                        path: "signatures", component: SigntureReport,
                    },
                ]
            },
            {
                path: "users",
                component: () => import("../views/users"),
                children: [
                    {
                        path: "list", component: UsersList,
                    },
                    {
                        path: "list/:user_id", name: 'users.show', component: UserSummary,
                    },
                    {
                        path: "roles", component: RolesList,
                    },
                    {
                        path: "permissions", component: PermissionsList,
                    },
                ]
            },
            {
                path: "settings", component: Settings,
            },
        ],
    },
];
